import Header from './components/Header';
import TabComponent from './components/TabComponent';

function App() {
  return (
    <div>
      <Header />
      <TabComponent />
    </div>
  );
}

export default App;
